import React, { Component } from 'react';
import { Icon, List, Toast, Button } from 'antd-mobile';
import { CommonlyHead } from "./headnav";
import * as services from '../projects/services';
import  CountDown  from '../../components/countDown';
import './style.less';
import Selfsvg from '../../components/selfsvg';

let Loadnum = 0;
export default class Pay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ids: this.props.match.params.orderid,
            ordernoList:"",
            orderidList: this.props.match.params.orderid.split(','),
            realmoney: 0,
            totalmoney: 0,
            totalcount: 0,
            orderDetailsList: [],
            orderDetails:'',
            totalMilliseconds:'',
            paylist: [],
            cardList: [],
            cardList2: [],
            rangeList: [],
            cards: [],
            checka: false,
            checkb: false,
            checkc: true,
            PaymentType: 3,
            integralSum: 0,
            actualPayment: 0,
            isWeixin: false,
            isalipay: false,
        }
        this.is_weixin = this.is_weixin.bind(this);

    }
    componentDidMount() {
        this.is_weixin();
        //获取订单信息
        let realmoney = this.state.realmoney;
        let totalmoney = this.state.totalmoney;
        let totalcount = this.state.totalcount;
        this.state.orderidList.forEach(element => {
            services.GetOrderDetails(element, '').then((data) => {
                if (data.status === 0) {
                    let orderDetails = data.result.orderDetails;
                    this.setState({orderDetails:orderDetails});
                    let orderno=this.state.ordernoList;
                    if(!!orderno)
                    {
                        orderno=orderno+','+orderDetails.orderno;
                    }else{
                        orderno=orderDetails.orderno;
                    }                    
                    this.setState({ordernoList:orderno});
                    realmoney += parseFloat(orderDetails.realmoney);
                    totalmoney += parseFloat(orderDetails.totalmoney);
                    totalcount += parseInt(orderDetails.totalcount);
                    let orderDetailsList = this.state.orderDetailsList;
                    orderDetailsList.push(orderDetails);
                    this.setState({totalMilliseconds:data.result.totalMilliseconds, orderDetailsList: orderDetailsList, realmoney: parseFloat(realmoney).toFixed(2), totalmoney: parseFloat(totalmoney).toFixed(2), totalcount: totalcount });
                } else {
                    Toast.offline(data.message);
                }
            });
        });
        services.GetList('支付方式', '').then((data) => {
            if (data.status === 0) {
                this.setState({ paylist: data.result });
            } else {
                Toast.offline(data.message);
            }
        });
        let parameter = { page: 1, rows: 100 };
        services.GetCardUnionList(parameter, '正在查询，请稍后').then((data) => {
            if (data.status === 0) {
                let cardList = data.result;
                if (!!cardList) {
                    cardList.forEach((item) => {
                        item.show = false;
                    })
                }
                this.setState({ cardList: !!cardList ? cardList : [] });
            } else {
                Toast.offline(data.message);
            }
        });
    }
    is_weixin = () => {
        var ua = navigator.userAgent.toLowerCase();
        this.setState({ stru: ua });
        this.setState({ isalipay: false });
        if (ua.match(/MicroMessenger/i) === "micromessenger" || ua.match(/micromessenger/i) === "micromessenger" || ua.match(/WeiBo/i) === "weibo") {
            this.setState({ isalipay: true });    
            return false;    
        }else if(ua.match(/MicroMessenger/i) !== null)
        {
            if (ua.indexOf('micromessenger') > -1) {
                this.setState({ isalipay: true });
                return false;    
            }
        }
        else if (ua.indexOf('mobile mqqbrowser') > -1) {
            this.setState({ isalipay: true });
            return false;    
          
        } else if (ua.indexOf('iphone') > -1 || ua.indexOf('mac') > -1) {
            if (ua.indexOf('qq') > -1) {
                this.setState({ isalipay: true });
                return false;    
            }
        }      
    }
    onClick = (data, e) => {
        let cardList = this.state.cardList;
        cardList.forEach(function
            (item) {
            if (item.publicId === data.publicId) {
                item.show = !item.show;
            }
        })
        this.setState({ cardList: !!cardList ? cardList : [] });
    }
    onpayClick = (value, e) => {
        if (value === 1) {
            this.setState({ checka: !this.state.checka, checkb: false, checkc: false });
        } else if (value === 2) {
            this.setState({ checka: false, checkb: !this.state.checkb, checkc: false });
        } else {
            this.setState({ checka: false, checkb: false, checkc: !this.state.checkc });
        }
    }
    AddOrder = () => {
        // orderIds （数组），PaymentType，cards（数组）  修改付款方式
        let cards = [];
        this.state.cardList.forEach(function
            (item) {
            if (item.show) {
                cards.push(parseInt(item.publicId));
            }
        })
        let PaymentType = this.state.PaymentType;
        if (this.state.checka) {
            PaymentType = 1;
        }
        else if (this.state.checkb) {
            PaymentType = 2;
        }
        else if (this.state.checkc) {
            PaymentType = 3;
        } else {
            PaymentType = '';
        }
        let cmorderidList = [];
        this.state.orderidList.forEach((item) => {
            item = parseInt(item);
            cmorderidList.push(item);
        })
        let parameter = { orderIds: cmorderidList, PaymentType: PaymentType, cards: cards };
        this.setState({ PaymentType: PaymentType });
        services.EditOrderPayment(parameter, '正在提交请稍后').then((data) => {
            if (data.status === 0) {                
                window.location.href = global.constants.tj_tijian + '/pay/wap?OrderID=' + this.state.ids;
            } else {
                Toast.offline(data.message);
            }
        });
    }
    render() {
        const { cardList, checka, checkc, orderDetailsList,orderDetails,totalMilliseconds } = this.state;
        let actualPayment = this.state.actualPayment;
        if (orderDetailsList.length > 0 && cardList.length > 0 && Loadnum < 1) {
            Loadnum++;
            cardList.forEach((item) => {
                item.cn = -1;
                if (item.children !== null) {
                    orderDetailsList.forEach((item2) => {
                        var i = item.children.findIndex((value) => value.unionCode === item2.mcno);
                        item.cn = i;
                    })

                } else {
                    item.cn = 1;
                }
            })
            var cn_num = cardList.findIndex((value) => value.cn > 0);
            if (cn_num >= 0) {
                cardList[cn_num].show = true;
            }
        }
        if (cardList.length > 0) {
            let integralSum_t = 0;
            cardList.forEach((item) => {
                if (item.show === true) {
                    integralSum_t += parseFloat(item.cardMoney);
                }
            })
            if (integralSum_t - this.state.totalmoney > 0) {
                actualPayment = 0;
            } else {
                actualPayment = parseFloat(Math.abs(parseFloat(integralSum_t) - parseFloat(this.state.totalmoney))).toFixed(2);
            }
        }

        return <div className="paybox">
            <CommonlyHead barname="支付" />
            <div className="paycontent">
                <Icon type="check-circle" size="lg" style={{ fill: '#ffb364', fontSize: '40px' }} />
                <div className="paytips">
                    <p>订单提交成功,等待体检人付款！<span className="fz12"></span>
                     {
                                        orderDetails.isclose === 0 && !!orderDetails.ispay === false && !!totalMilliseconds
                                        ?                                  
                                        <span className="footera">
                                    剩<CountDown endTime= {totalMilliseconds} />自动关闭</span>
                                    :''
                                      }  
                    </p>
                    <p>订单号：{this.state.ordernoList}，金额：<span>￥{this.state.totalmoney}</span></p>
                </div>               
            </div>
            <div className="paytipsa">温馨提示：因体检耗材或工本费产生的价格差异，按照实际体检金额多退少补</div>           
            <List renderHeader={() => '健康积分'}>
                {
                    cardList.length === 0 && orderDetailsList === 0 ? '' :
                        cardList.map((data, index) => (
                            data.cn > -1 ?
                                <List.Item key={index} onClick={this.onClick.bind(this, data)}>
                                    <div className="flexdiv"><img alt="" className="zsvg" src={require('../../res/images/logo.png')} /><span className="title">{data.cardCode}<span className="coloro">(积分：{data.cardMoney} )</span></span><Icon className="checkico" style={{ fill: data.show === true ? '#32a128' : '#cccccc' }} type={data.show === true ? 'check-circle' : 'check-circle-o'} />
                                    </div>
                                </List.Item> :
                                <List.Item key={index} style={{ background: '#f5f5f5' }}>
                                    <img className="zsvg" alt="" src={require('../../res/images/logo.png')} /><span className="title">{data.cardCode}<span className="coloro">(积分：{data.cardMoney} )</span></span><span className="ts">（不支持该订单支付）</span>
                                </List.Item>
                        ))
                }
            </List>
            <List renderHeader={() => '选择支付方式'}>

                {
                    this.state.isalipay ? '' :
                        <List.Item onClick={this.onpayClick.bind(this, 1)}>
                            <Selfsvg name="alipay" width={30} height={30} color={'#1195db'} /><span className="title">支付宝支付</span><Icon className="checkico" style={{ fill: checka === true ? '#32a128' : '#cccccc' }} type={checka === true ? 'check-circle' : 'check-circle-o'} />
                        </List.Item>
                }

                <List.Item onClick={this.onpayClick.bind(this, 3)}>
                    <Selfsvg name="WeChat" width={30} height={30} color={'#ffb364'} /><span className="title">微信支付</span><Icon className="checkico" style={{ fill: checkc === true ? '#32a128' : '#cccccc' }} type={checkc === true ? 'check-circle' : 'check-circle-o'} />
                </List.Item>
                {/* <List.Item onClick={this.onpayClick.bind(this, 2)}>
                    <Selfsvg name="UnionPay" width={30} height={30} color={'#1195db'} /><span className="title">银联支付</span><Icon className="checkico" style={{ fill: checkb === true ? '#32a128' : '#cccccc' }} type={checkb === true ? 'check-circle' : 'check-circle-o'} />
                </List.Item> */}
            </List>           
            <div className="footer">
                <div className="footerbox footerbox2">
                    <div className="fbigBtn settlementbox">
                        <table className="checkboxa">
                            <tbody>
                            <tr>
                                <td valign="middle">
                                <span >共</span>
                            <span className="hprice">{this.state.totalcount}</span>
                            <span >件，应付</span>
                            <span className="hprice">{this.state.totalmoney}</span>
                            <span >, 实付</span>
                            <span className="hprice">{actualPayment}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Button className="fbigBtn settlementBtn" onClick={this.AddOrder}>立即支付</Button>
                </div>
            </div>
        </div>
    }
}